export class RestoreAwsExternalRecoveryPointRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAwsExternalRecoveryPointRequest.attributeTypeMap;
    }
    constructor() {
    }
}
